<p-toast position="top-center"></p-toast>

<app-page-shell>
    @if (isLoading) {
        <p-progressBar mode="indeterminate"></p-progressBar>
    }

    @if (canViewServices) {
        <app-page-hero
            eyebrow="Customs Clearance"
            title="Clearance Services"
            subtitle="Maintain the chargeable service catalog used by clearance jobs, variants, and billing lines.">
            <div actions>
                <p-button label="Refresh" icon="pi pi-refresh" severity="secondary" [outlined]="true"
                    (click)="loadData()"></p-button>
                @if (canCreateService) {
                    <p-button label="New Service" icon="pi pi-plus" (click)="addClearanceService()"></p-button>
                }
            </div>
        </app-page-hero>

        <app-page-metric-strip [metrics]="metrics"></app-page-metric-strip>

        <app-page-data-panel title="Service Catalog" subtitle="Search service definitions and expand rows to inspect configured variants.">
            <div class="service-toolbar">
                <span class="search-field">
                    <i class="pi pi-search"></i>
                    <input pInputText [(ngModel)]="searchTerm" placeholder="Search services or descriptions">
                </span>
            </div>

            <p-table [value]="visibleServices" dataKey="serviceID" [resizableColumns]="true"
                styleClass="p-datatable-sm service-table" [tableStyle]="{ 'min-width': '60rem' }"
                [paginator]="true" [rows]="20" [first]="first" [showCurrentPageReport]="true"
                [totalRecords]="visibleServices.length"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} services"
                [rowsPerPageOptions]="[20, 50, 100]">
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width: 4rem"></th>
                        <th>Service</th>
                        <th>Description</th>
                        <th>Buying</th>
                        <th>Selling</th>
                        <th>Variants</th>
                        <th>Actions</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-clearanceService let-expanded="expanded">
                    <tr>
                        <td>
                            <p-button type="button" [text]="true" [rounded]="true" severity="secondary"
                                [pRowToggler]="clearanceService"
                                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></p-button>
                        </td>
                        <td>
                            <div class="service-name">{{ clearanceService.serviceName }}</div>
                            <small>#{{ clearanceService.serviceID || '-' }}</small>
                        </td>
                        <td>{{ clearanceService.description || '-' }}</td>
                        <td>{{ formatAmount(clearanceService.buyingAmount) }}</td>
                        <td>{{ formatAmount(clearanceService.sellingAmount) }}</td>
                        <td>
                            <p-tag [value]="(clearanceService.variants?.length || 0) + ' variants'"
                                severity="info"></p-tag>
                        </td>
                        <td>
                            @if (canEditService) {
                                <p-button type="button" icon="pi pi-pencil" [rounded]="true" [text]="true"
                                    severity="info" pTooltip="Edit Clearance Service"
                                    (click)="editClearanceService(clearanceService)"></p-button>
                            }
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="expandedrow" let-clearanceService>
                    <tr>
                        <td colspan="7">
                            <div class="variant-panel">
                                <div class="variant-heading">
                                    <span>Service Variants</span>
                                    <p-tag [value]="(clearanceService.variants?.length || 0) + ' configured'"
                                        severity="secondary"></p-tag>
                                </div>
                                <p-table [value]="clearanceService.variants || []" dataKey="variantID"
                                    styleClass="p-datatable-sm variant-table">
                                    <ng-template pTemplate="header">
                                        <tr>
                                            <th>Variant</th>
                                            <th>Description</th>
                                            <th>Buying Adjustment</th>
                                            <th>Selling Adjustment</th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-line>
                                        <tr>
                                            <td>{{ line.variantName }}</td>
                                            <td>{{ line.description || '-' }}</td>
                                            <td>{{ formatAmount(line.buyingAmountAdjustment) }}</td>
                                            <td>{{ formatAmount(line.sellingAmountAdjustment) }}</td>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="emptymessage">
                                        <tr>
                                            <td colspan="4">No variants configured for this service.</td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="7">No clearance services found.</td>
                    </tr>
                </ng-template>
            </p-table>
        </app-page-data-panel>
    } @else {
        <app-page-hero eyebrow="Customs Clearance" title="Clearance Services" subtitle="You do not have permission to view clearance services."></app-page-hero>
    }
</app-page-shell>
